// src/components/TimeCapsuleMap.js
import React, { memo, useMemo } from 'react';
import {
    GoogleMap,
    Marker,
    MarkerClusterer,
    Circle,
    DirectionsRenderer,
} from '@react-google-maps/api';
import IconBuryTimeCapsule from '../assets/icons/icon-bury-capsule.png';
import UserLocationMarker from './UserLocationMarker';

const TimeCapsuleMap = memo(function ({
    center,
    userLocation,
    markers,
    directions,
    onLoad,
    onDrag,
    onIdle,
    onMarkerClick,
    mapOptions,
    containerStyle,
    isDragging,
}) {
    const userCircle = useMemo(
        () =>
            userLocation && (
                <Circle
                    key="user-location-circle"
                    center={userLocation}
                    radius={1000}
                    options={{
                        fillColor: '#1152E4',
                        fillOpacity: 0.1,
                        strokeColor: '#1152E4',
                        strokeOpacity: 0.4,
                        strokeWeight: 1,
                        clickable: false,
                        zIndex: 1,
                    }}
                />
            ),
        [userLocation]
    );

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={17}
            onLoad={onLoad}
            onDrag={onDrag}
            onIdle={onIdle}
            options={mapOptions}
        >
            {userLocation && <UserLocationMarker position={userLocation} />}

            <MarkerClusterer>
                {clusterer =>
                    markers.map(m => (
                        <Marker
                            key={m.id}
                            position={m.position}
                            clusterer={clusterer}
                            icon={{
                                url: m.icon,
                                scaledSize: new window.google.maps.Size(m.width, m.height),
                                anchor: new window.google.maps.Point(m.width / 2, m.height),
                            }}
                            onClick={() => onMarkerClick(m)}
                        />
                    ))
                }
            </MarkerClusterer>

            {userCircle}

            {directions && (
                <DirectionsRenderer
                    directions={directions}
                    options={{ preserveViewport: true, suppressMarkers: true }}
                />
            )}

            {isDragging && (
                <Marker
                    position={center}
                    clickable={false}
                    icon={{
                        url: IconBuryTimeCapsule,
                        scaledSize: new window.google.maps.Size(32, 32),
                        anchor: new window.google.maps.Point(16, 32),
                    }}
                    zIndex={999}
                />
            )}
        </GoogleMap>
    );
});

export default TimeCapsuleMap;
